<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="max-w-screen-xl px-4 py-8 mx-auto lg:px-6 sm:py-16 lg:py-24">
      <DoctorAppointmentHeader />

      <DoctorAppointmentNotice />

      <ClientOnly fallback-tag="span" fallback="Loading Scheduler...">
        <DoctorSchedulerDatePicker />
      </ClientOnly>
      <DoctorAppointmentForm />

    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useFlowbite } from '~/composables/useFlowbite';

// initialize components based on data attribute selectors
onMounted(() => {
  useFlowbite(() => {
    initFlowbite();
  })
})
const { doctorDetails } = useSearch()

</script>